// @flow

import type { Node } from 'react';

type TProps = {
  setPopupContent: (N: Node) => void
};

export const Header = 'Min. Clarity';

export function Content({ setPopupContent }: TProps) {
  return (
    <div>
      <p>
        The minimum clarity grade assigned to any diamond within a particular
        accent group. Accent diamonds are not GIA graded; this grade is
        determined by Lumera.
      </p>
    </div>
  );
}
